import { CalendarViewType } from '../types/calendar-view-type';

export interface PeriodRange {
  start: Date;
  end: Date;
}

/** The date span a roster view loads for `date`; `planMonth` is the range the user picked. */
export function periodRange(
  date: Date,
  viewType: CalendarViewType,
  planMonth?: PeriodRange | null
): PeriodRange {
  switch (viewType) {
    case 'day': {
      const end = new Date(date);
      end.setHours(23, 59, 59, 0);
      return { start: new Date(date), end };
    }
    case 'week':
    case 'workWeek': {
      const weekday = date.getDay();
      const start = new Date(date);
      start.setDate(date.getDate() - (weekday === 0 ? 6 : weekday - 1));
      const end = new Date(date);
      end.setDate(date.getDate() + (weekday === 0 ? 0 : 7 - weekday));
      return { start, end };
    }
    case 'month':
      return {
        start: new Date(date.getFullYear(), date.getMonth(), 1),
        end: new Date(date.getFullYear(), date.getMonth() + 1, 0),
      };
    case 'planMonth':
      if (planMonth) return { start: planMonth.start, end: planMonth.end };
      return { start: new Date(date), end: new Date(date) };
    default:
      return { start: new Date(date), end: new Date(date) };
  }
}
